import { DatasetsCrudController, ApiCrudObjectControllerBindings } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Provides UI for viewing and editing datasets.
 * @example
 * ```html
 * <salaxy-dataset-details></salaxy-dataset-details>
 * ```
 */

export class DatasetDetails extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
   public bindings = (new class extends ApiCrudObjectControllerBindings {
    /** Type of user interface to show. */
    public mode = "@";

    /** Defines the default usecase (uri) that is used for new calculations. */
    public defaultUsecase = "@";
  }());

  /** Uses the DatasetsCrudController */
  public controller = DatasetsCrudController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/workflow/dataset/DatasetDetails.html";

}
